<div class="register-container">
  <div class="register-form-container">

    <div class="register-username-text">
      {{getString('registerUsernameText')}}
    </div>

    <div class="form-field">
      <app-input-field [label]="getString('username')" [placeholder]="getString('username')" (valueChanged)="onUsernameChange($event)"></app-input-field>
    </div>

    <div class="username-instructions">
      {{getString('usernameInstructions')}}
    </div>

    <div class="red-text">
      <span class="block" *ngIf="!success">{{getString('registrationFailed')}}</span>
      <span class="block" *ngIf="serverError">{{serverErrorMessage}}</span>
      <span class="block" *ngIf="invalidUsername">{{invalidUsernameMessage}}</span>
    </div>

    <div class="txt-algn-cntr">
      <input type="checkbox" id="privacyPolicyCheckbox">
      {{getString('iveReadAndAgree')}}
      <a class="privacy-policy" href="https://api.cheapcharts.com/CheapCharts/API/HTML-Pages/privacy.php"
      target="_blank">{{getString('privacyPolicy')}}
      </a>
    </div>

    <div class="form-field">
      <button class="register-button blue-button" type="button" (click)="register()">{{getString('register')}}</button>
    </div>

    <div class="red-text" *ngIf="privacyPolicyError">{{getString('privacyPolicyError')}}</div>

  </div>
</div>
